import React from 'lib/react';
import {
  EVGrid, makeStyles,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import { useSelector } from 'lib/redux';
import Typography from 'commonComponents/typography';
import FinalizeOrderExpansionPanel from './FinalizeOrderExpansionPanel.component';
import MeasurementInstructionsHelperComponent from '../../../commonComponents/measurementInstructionHelper/MeasurementInstructionsHelper.component';

const useStyles = makeStyles((theme) => ({
  measurementInstructionsContainer: {
    backgroundColor: theme.evPalette.salt[100],
    padding: '0px',
    display: 'flex',
    width: '60%',
    flexDirection: 'column',
    gap: '24px',
    '@media (max-width: 640px)': {
      width: '100%',
    },
  },
  measurementInstructionsExpansion: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '0px',
  },
}));

function MeasurementInstructions() {
  const classes = useStyles();
  const { t } = useTranslation();
  const selectedMeasurementRequest = useSelector((state) => state.order.selectedMeasurementRequest);
  const orderMeasurementRequestHelpText = `order_measurementrequest_helptext_${selectedMeasurementRequest}`;
  const getPanelHeader = (header) => (<EVGrid>{header}</EVGrid>);

  return (
    <FinalizeOrderExpansionPanel
      panelSummary={getPanelHeader(t('order_measurementinstructions'))}
      defaultExpanded
    >
      <EVGrid className={classes.measurementInstructionsExpansion}>
        <EVGrid className={classes.measurementInstructionsContainer}>
          <MeasurementInstructionsHelperComponent inputProps={{ readOnly: true }} />
        </EVGrid>
        <Typography variant="subtitle-400">
          {t(orderMeasurementRequestHelpText)}
        </Typography>
      </EVGrid>
    </FinalizeOrderExpansionPanel>
  );
}

export default MeasurementInstructions;
